@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;


<div [ngClass]="{smallScreen, mediumScreen, largeScreen}" id="about-page">

    <header>

        <div class="title">
            <lucide-angular name="videotape" size="44" strokeWidth="2"></lucide-angular>
            <h1 class="about-title">{{ 'about.title' | translate }}</h1>
        </div>
        <p class="about-description">{{ 'about.description' | translate }}</p>
    </header>

    <ul class="about-links">
        <li>
            <a routerLink="/privacy">{{ 'policy.title' | translate }}</a>
        </li>
        <li>
            <a routerLink="/terms">{{ 'terms.title' | translate }}</a>
        </li>
    </ul>
</div>